export default {
    en: {
        users                            : "Users",
        administrator                    : "Administrator",
        agent                            : "Agent",
        unknown                          : "Unknown",
        display_name                     : "Display Name",
        email                            : "Email",
        role                             : "Role",
        created_at                       : "Created At",
        updated_at                       : "Updated At",
        notification_type                : "Notification",
        push_notification                : "Will be notified with Push Notifications",
        sms                              : "Will be notified with SMS at {number}",
        edit                             : "Edit",
        deactivate                       : "Deactivate",
        activate                         : "Activate",
        activation_notification_title    : "Account Activation",
        activation_notification_message  : "The user <strong>{username}</strong> account has been activated",
        deactivation_notification_title  : "Account Deactivation",
        deactivation_notification_message: "The user <strong>{username}</strong> account has been deactivated"
    },
    el: {
        users                            : "Χρήστες",
        administrator                    : "Διαχειριστής",
        agent                            : "Μεσίτης",
        unknown                          : "Άγνωστος",
        display_name                     : "Όνομα",
        email                            : "Διεύθυνση Email",
        role                             : "Ρόλος",
        created_at                       : "Δημιουργήθηκε",
        updated_at                       : "Ενημερώθηκε",
        notification_type                : "Ειδοποίηση",
        push_notification                : "Θα ειδοποιηθεί με Push Notifications",
        sms                              : "Θα ειδοποιηθεί με SMS στο {number}",
        edit                             : "Επεξεργασία",
        deactivate                       : "Απενεργοποίηση",
        activate                         : "Ενεργοποίηση",
        activation_notification_title    : "Ενεργοποίηση Λογαριασμού",
        activation_notification_message  : "Ο λογαριασμός του χρήστη <strong>{username}</strong> έχει ενεργοποιηθεί",
        deactivation_notification_title  : "Απενεργοποίηση Λογαριασμού",
        deactivation_notification_message: "Ο λογαριασμός του χρήστη <strong>{username}</strong> έχει απενεργοποιηθεί"
    }
};